<template>
    <div>
        <my-search v-model="pgData" @search="searchHandler">
            <el-form-item slot="title">
                <el-input v-model="pgData.txtkey" placeholder="招标人名称" clearable></el-input>
            </el-form-item>
            <span slot="time"></span>

            <template slot="btn">
                <el-button type="success" icon="el-icon-plus" @click="dialogShow">添加招标人</el-button>

                <el-button type="warning" icon="el-icon-search" @click="toCodes">查询统一信用代码</el-button>
            </template>
        </my-search>

        <my-table :data="tableData">
            <el-table-column label="招标人" prop="name" min-width="160"></el-table-column>
            <el-table-column label="营业执照代码" prop="orgcode" min-width="180"></el-table-column>
            <el-table-column label="联系人" prop="lxr" width="80"></el-table-column>
            <el-table-column label="联系电话" prop="tel" width="140"></el-table-column>
            <el-table-column label="操作" width="80" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-check" @click="clickHandler(scope.row)">选中</el-button>
                </template>
            </el-table-column>
        </my-table>

        <my-pagination 
            ref="page" 
            v-model="tableData" 
            :action="`${getGetters('mngUrl')}/tree/get_zbrlist.json`"
            :search="pgData"
        ></my-pagination>

        <my-dialog 
        v-model="dialogVisible" 
        width="550px" 
        title="添加招标人"
        >
            <add-zbr @cancle="dialogClose"></add-zbr>
        </my-dialog>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import DIALOG_LIST_PAGE_MIXIN from '@views/mixins/dialog-list-page'
import MODEL from '@/mixins/model'
import TWO_WAY from '@/mixins/2way'

import AddZbr from './add-zbr'

export default {
    mixins: [MODEL, TWO_WAY, LIST_PAGE_MIXIN, DIALOG_LIST_PAGE_MIXIN],
    components: {AddZbr},
    props: {
        props: {
            type: Object,
            default: () => ({
                value: 'orgcode'
            })
        }
    },
    data () {
        return {
            tableData: [],
            pgData: {
                txtkey: ''
            }
        }
    },
    methods: {
        clickHandler(row) {
            this.twoWayHandler(row);
            this.model = row[this.props.value];

            this.$emit('select', row);
        },
        toCodes() {
            window.open('https://www.cods.org.cn/');
        }
    }
}
</script>

<style>

</style>